<template>
  <v-card :loading="loading">
    <v-card-text v-if="!loading">
      <v-tabs color="primary" right>
        <v-tab>Pianificazione</v-tab>
        <v-tab>Visualizza Pianificazione</v-tab>
        <v-tab>Eventi di oggi/domani</v-tab>
        <!-- <v-tab>Abstract</v-tab> -->
        <v-tab-item :key="1">
          <FrmEditPlanner
            ref="frmEditPlanner"
            key="2"
            :plannerSettings="settings.planner"
            :mode="PlannerMode.Planner"
          ></FrmEditPlanner>
        </v-tab-item>

        <v-tab-item :key="2">
          <FrmEditPlanner
            ref="frmEditPlannerViewer"
            key="1"
            :mode="PlannerMode.PlannerViewer"
            :plannerSettings="settings.plannerViewer"
          ></FrmEditPlanner>
        </v-tab-item>
        <v-tab-item :key="3">
          <FrmEditEventViewer
            ref="frmEditEventViewer"
            :dayEventViewerSettings="settings.dayEventViewer"
          ></FrmEditEventViewer>
        </v-tab-item>
      </v-tabs>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" :loading="saving" @click="btnSave_Click"
        >Salva</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
import FrmEditPlanner from "./Pages/FrmEditPlanner.vue";
import FrmEditEventViewer from "./Pages/FrmEditEventViewer.vue";
import UISettingsHelper from "../../utils/UISettingsHelper";

 import PlannerMode from '../../settings/PlannerMode' 
const settingsKey = "test";
export default {
  components: {
    FrmEditPlanner,
    FrmEditEventViewer, 
  },
  
  created() {
    // this.settings.planner.daysToShow = [0,1,2,3,4,5];
    this.loadSettings();
  },
  mounted() {
    //    this.loadSettings();
    //  this.$refs.frmEditPlanner.SetPlannerSettings(this.settings.planner);
  },
  computed: {
    dayEventViewerSecondsSpeed() {
      let num = 10 / this.settings.dayEventViewer.scrollerSpeed;
      return 10 - this.settings.dayEventViewer.scrollerSpeed + 1; // Math.round(num * 100) / 100
    },
  },
  methods: {
    async btnSave_Click() {
      if (this.$refs.frmEditPlanner !== undefined)
        this.settings.planner = this.$refs.frmEditPlanner.GetSettings();

      if (this.$refs.frmEditPlannerViewer !== undefined)
        this.settings.plannerViewer = this.$refs.frmEditPlannerViewer.GetSettings();

      if (this.$refs.frmEditEventViewer !== undefined)
        this.settings.dayEventViewer = this.$refs.frmEditEventViewer.GetSettings();
      await this.saveSettings();
    },
    visibleDaysChanged() {
      console.log("days", this.settings.planner.daysToShow);
      this.saveSettings();
    },
    visibleDaysSelect() {
      console.log("days", this.settings.planner.daysToShow);
    },
    async loadSettings() {
      this.loading = true;
      let updatedSettings = await UISettingsHelper.Pull(
        this.$route.params.companyAlias
      );
      console.debug("UPDATE_SETTINGS", updatedSettings);
      if (updatedSettings) {
        console.debug("updated", updatedSettings);
      }
      UISettingsHelper.LoadSettings();
      let tmpSettings = UISettingsHelper.GetSettings();
      if(tmpSettings.plannerViewer===undefined){
        tmpSettings.plannerViewer={... tmpSettings?.planner};
        await this.saveSettings();
      } 
        this.settings=tmpSettings;
      this.loading = false;
    },
    async saveSettings() {
      this.saving = true;
      console.debug("this.settings", this.settings);
      UISettingsHelper.SetSettings(this.settings);
      console.debug("saving", this.settings);
      UISettingsHelper.SaveSettings();
      console.debug("saved,pushing", this.settings);
      let updatedSettings = await UISettingsHelper.Push(
        this.$route.params.companyAlias
      );

      // UISettingsHelper.Push( this.$route.params.companyAlias,(updatedSettings)=>{

      console.debug("pushed", this.settings);
      this.saving = false;
      //});
      // UISettingsHelper.s
      // this.settings=UISettingsHelper.GetSettings();
      //   localStorage.setItem(settingsKey, JSON.stringify(this.settings));
      // },
    },
  },
  data() {
    return {
      loading: false,
      saving: false,
      PlannerMode:{...PlannerMode},
      settings: {
        planner: {
          scrollerSpeed: 2,
          fitVisibleDays: true,
          maxDaysToShow: 6,
          startFromToday: true,
          daysToShow: [],
          operatorsAbsenceReasons: ["Corsi", "Ferie", "Malattia", "Visita"],
          vehiclesAbsenceReasons: ["Fermo", "Manutenzione", "Noleggio"],
          equipmentsAbsenceReasons: ["Collaudo", "Guasto"],
        },
        plannerViewer: {
          scrollerSpeed: 2,
          fitVisibleDays: true,
          maxDaysToShow: 6,
          startFromToday: true,
          daysToShow: [],
          operatorsAbsenceReasons: ["Corsi", "Ferie", "Malattia", "Visita"],
          vehiclesAbsenceReasons: ["Fermo", "Manutenzione", "Noleggio"],
          equipmentsAbsenceReasons: ["Collaudo", "Guasto"],
        },
        dayEventViewer: {
          scrollerSpeed: 10,
          maxItemPerPage: 5,
        },
      },
    };
  },
};
</script>
../../settings/PlannerMode